export default __webpack_public_path__ + "images/VF.59a81d8.png";